import React, { Component } from "react";
import "../style/Home.css";
import FrogHead5 from "../assets/Frog_Head_5.png";
import PlayBtn from "../assets/play.png";
import BuyImg from "../assets/buy.png";

export class HomeTile extends Component {
  render(props) {
    return this.props.isMainTile ? (
      <div className="home-tile home-tile-main">
        <span className="home-tile-span">{this.props.text}</span>
        <img src={FrogHead5} alt="" className="frog-img" id="homeFrog" />
        <img src={PlayBtn} alt="" id="buyImg" />
        <span className="home-tile-span">SOON!</span>
      </div>
    ) : (
      <div className="home-tile">
        <span className="home-tile-span">{this.props.text}</span>
        <img className="home-tile-img" src={this.props.img}></img>
        {this.props.explore ? (
          <span className="home-tile-span">TOKENS!</span>
        ) : (
          <span className="home-tile-span">MEET US!</span>
        )}
      </div>
    );
  }
}

export default HomeTile;
